import { Route } from '@angular/router';

export const myTeamRoutes: Route[] = [
  {
    path: '',
    async loadComponent() {
      const c = await import('./my-team.component');
      return c.MyTeamComponent;
    },
  },
  {
    path: 'details/:id',
    async loadComponent() {
      const c = await import(
        './subordinates-details/subordinates-details.component'
      );
      return c.SubordinatesDetailsComponent;
    },
  },
  {
    path: 'request/:requestAction/:flowId',
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.RequestViewComponent;
    },
  },
  {
    path: 'request/:requestAction/:flowId/:stepId/:userId/:userType',
    async loadComponent() {
      const c = await import('@kuiper/ibusiness-core');
      return c.RequestComponent;
    },
  },
];
